const HowItWorksAlt = () => {
  return (
    <section className="py-32 px-4 bg-background">
      <div className="container mx-auto max-w-6xl">
        <div className="mb-20">
          <h2 className="text-5xl md:text-7xl font-black mb-6 text-foreground">
            HOW WE WORK
          </h2>
          <p className="text-2xl font-bold text-muted-foreground max-w-3xl">
            We connect <span className="text-accent">founders</span>, <span className="text-accent">partners</span>, and <span className="text-accent">customers</span> through ecosystem-driven growth strategies.
          </p>
        </div>

        <div className="space-y-20">
          {/* Step 1 */}
          <div className="grid md:grid-cols-12 gap-8 items-start">
            <div className="md:col-span-2">
              <div className="text-8xl font-black text-accent">01</div>
            </div>
            <div className="md:col-span-10 space-y-4 pt-4 border-l-4 border-accent pl-6">
              <h3 className="text-3xl md:text-4xl font-black text-foreground">
                DISCOVER & CONNECT
              </h3>
              <p className="text-xl text-foreground leading-relaxed max-w-2xl">
                We identify innovative solutions and match them with the right partners and customers. Our <span className="font-semibold text-accent">network spans hyperscalers</span>, enterprise customers, and strategic partners across key markets.
              </p>
            </div>
          </div>

          {/* Step 2 */}
          <div className="grid md:grid-cols-12 gap-8 items-start">
            <div className="md:col-span-2">
              <div className="text-8xl font-black text-primary">02</div>
            </div>
            <div className="md:col-span-10 space-y-4 pt-4 border-l-4 border-primary pl-6">
              <h3 className="text-3xl md:text-4xl font-black text-foreground">
                INTEGRATE & COLLABORATE
              </h3>
              <p className="text-xl text-foreground leading-relaxed max-w-2xl">
                We facilitate seamless integration between portfolio companies, partners, and customers. <span className="font-semibold text-primary">Solutions get embedded</span> into existing platforms and distribution networks for mutual benefit.
              </p>
            </div>
          </div>

          {/* Step 3 */}
          <div className="grid md:grid-cols-12 gap-8 items-start">
            <div className="md:col-span-2">
              <div className="text-8xl font-black text-accent">03</div>
            </div>
            <div className="md:col-span-10 space-y-4 pt-4 border-l-4 border-accent pl-6">
              <h3 className="text-3xl md:text-4xl font-black text-foreground">
                GROW TOGETHER
              </h3>
              <p className="text-xl text-foreground leading-relaxed max-w-2xl">
                Success through collaboration. <span className="font-semibold text-accent">Founders scale faster</span>, partners unlock new revenue, and customers gain access to innovative solutions—all through our ecosystem-led approach.
              </p>
            </div>
          </div>
        </div>

        {/* Quote */}
        <div className="mt-32 p-12 bg-secondary border-l-4 border-accent">
          <blockquote className="text-3xl md:text-4xl font-black leading-tight text-foreground">
            "WE BUILD BRIDGES BETWEEN INNOVATION AND OPPORTUNITY—WHERE FOUNDERS, PARTNERS, AND CUSTOMERS THRIVE TOGETHER."
          </blockquote>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksAlt;
